<template>
  <div class="main_div">
    <div class="flex">
      <div class="drug_select">
        <v-select ref="vue_select" v-model="drug" @keypress.enter.native.prevent="" @input="select" label="title" placeholder="Препарат" :filterable="false"
                  :options="options"
                  @search="onSearchDrug">
          <template slot="no-options">
            введите название препарата..
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.title }} :: {{option.veshchestvo}}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            {{ option.title }}
          </template>
        </v-select>
      </div>
      <div>
        <input @change="updateQty" v-if="drug"
               v-model="drug.qty"
               type="number"
               class="form-control border-r-0"
               name="qty"
               placeholder="Количество"
        >
<!--        v-validate="'required|integer'"-->
<!--        data-vv-as="Количество"-->

        <small class="form-text text-danger" v-if='errors.has("qty")'>
          {{ errors.first("qty") }}
        </small>
      </div>
      <div v-if="drug && drug.holod" class="cool_mark"><i class="icon icon-snowflake"/></div>
      <div v-if="drug && getDiscountPrices(drug)" class="cool_mark">
        <i class="icon icon-fa icon-fa-percent"
           v-tooltip="{ show: toolOpen, placement: 'bottom-center', content: getDiscountPrices(drug, true) ,classes: ['discount_tooltip']}"></i>
      </div>
      <div v-if="drug">
        <v-popover :auto-hide="true" popoverClass="info_drug_popover_wrapper" popoverInnerClass="info_drug_popover" placement="left">

          <button @click="getDrugInfo(drug.id, true)" style="height: 38px" class="btn btn-info btn-xs border-r-0"><i class="icon-fa icon-fa-info"></i></button>

          <template slot="popover">
            <template v-if="drugData[drug.id] && drugData[drug.id][siteId] && drugData[drug.id][siteId].info">
              <div v-html="printDrugInfo(drugData[drug.id][siteId].info)"></div>
            </template>
            <template v-else>
              Загрузка ....
            </template>

            <button v-close-popover class="btn btn-theme btn-sm">Закрыть</button>
          </template>
        </v-popover>
      </div>
    </div>
    <div class="price_info" v-if="drug">
      <p v-if="drug.komplekt && drug.komplekt != 1">
        <i class="icon-fa icon-fa-info-circle drugset_info"/> комплект <strong>{{drug.komplekt}}</strong> * <strong class="actual_drug_price">{{drugActualPrice}}</strong>
      </p>
      <p>
        <span>страна поставки: <strong>{{drug.import_country.full_country}}</strong></span>
        <span v-if="drug.valid_dates && drug.valid_dates.length">срок годности: <strong>{{printValidDates(drug.valid_dates)}}</strong></span>
        <span> стоимость: <strong class="actual_drug_price">{{drugActualPrice * (drug.komplekt && drug.komplekt != 1 ? drug.komplekt : 1)}} </strong></span>
        <span v-if="drug.lgot_price" class="badge badge-success">Льготная доставка</span>
      </p>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import vSelect from 'vue-select';

  export default {
    components: {
      vSelect,
    },
    props: [
      'selectedDrug', 'incomeDrug', 'siteId'
    ],
    data() {
      return {
        toolOpen: false,
        drug: null,
        searchLoading: false,
        options: [],
        drugData: {},
        drugActualPrice: 0,
      }
    },
    watch: {
      'incomeDrug': {
        handler: function (val, oldVal) {
          if (this.incomeDrug && this.incomeDrug.id) this.drug = this.incomeDrug;
        },
        deep: true
      },
    },
    created() {
      if (this.incomeDrug && this.incomeDrug.id) this.drug = this.incomeDrug;
    },
    methods: {
      getPriceByQty(prices, qty, useSiteId = true) {
        let sortedPrices = _.orderBy(prices, 'qty', 'desc');
        let price = 0;
        sortedPrices.forEach((p) => {
          if (useSiteId) {
            if (p.site_id == this.siteId && qty >= p.qty && price === 0) price = p.price;
          } else {
            if (qty >= p.qty && price === 0) price = p.price;
          }
        });
        if (price === 0) {
          price = sortedPrices[Object.keys(sortedPrices)[0]].price;
        }
        this.drugActualPrice = price;
        return price;
      },
      printValidDates(dates) {
        if (!dates) return;
        let arr = [];
        dates.forEach((d) => {
          arr.push(('0' + d.month).slice(-2) + '.' + d.year);
        });
        return arr.join(', ');
      },
      printDrugInfo(data) {
        if (data.error) {
          return '<p class="color-red">' + data.error + '</p>';
        }
        let text = '<div class="flex"><div><img src="' + data.image_link + '" alt=""></div><div>';
        text += '<p>Препарат <a href="' + data.link + '" target="_blank">' + data.name + '</a></p>';
        data.options.forEach((opt) => {
          text += '<p>' + opt.title + ': <strong>' + opt.value + '</strong></p>';
        });
        text += '</div></div>';
        return text;

      },
      async getDrugInfo(id) {
        if (this.drugData[id] && this.drugData[id][this.siteId] && this.drugData[id][this.siteId].info) return;

        let {data} = await api.post('/drugs/getInfoBySite', {site: this.siteId, drug: id, update: true});

        if (!this.drugData[id]) this.drugData[id] = {};
        if (data.success) {
          if (!this.drugData[id][this.siteId]) this.drugData[id][this.siteId] = {};
          this.drugData[id][this.siteId].info = data.drugInfo.info;
        } else {
          this.drugData[id][this.siteId] = {error: data.message};
        }
        this.drugData = {...this.drugData};
      },
      getDiscountPrices(drug, print = false) {
        let prices = 0;
        let text = '';
        drug.prices.forEach((p) => {
          if (p.site_id == this.siteId) {
            text += '<p>от ' + p.qty + ' шт. цена <strong>' + p.price + '</strong> руб.</p>';
            ++prices;
          }
        });
        if (!print) return prices > 1 ? true : false;
        return text;
      },
      updateQty() {
        this.$set(this.drug, 'actual_price', this.getPriceByQty(this.drug.prices, this.drug.qty));
        this.selectedDrug(this.drug);
      },
      select(e) {
        // console.log(e);
        if (e) {
          e.qty = 1;
          this.$set(this.drug, 'actual_price', this.getPriceByQty(this.drug.prices, this.drug.qty));
        }
        this.selectedDrug(this.drug);

        // this.drug = null;
      },
      onSearchDrug(search, loading) {

        if (!search || search.length < 2) {
          this.searchLoading = false;
          return;
        }
        // this.searchLoading = true;
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce((loading, search, vm) => {
        fetch(
          `/api/noa/getDrugByName?search=${encodeURIComponent(search)}`
        ).then(res => {

          res.json().then(json => (vm.options = json.items));
          loading(false);
        });
      }, 300),
    }
  }


</script>

<style scoped>
  .price_info{
    margin-top:10px;
  }
  .price_info p{
    margin-bottom: 5px;
  }
</style>

<style>
  .actual_drug_price {
    background-color: #4fc47f;
    color: white;
    padding: 2px 5px;
  }
  .main_div input,
  .main_div button {
    border-radius: 0 !important;
  }

  .discount_tooltip {
    top: 1px !important;
    left: -2px !important;
    background-color: white;
    border: 1px solid #ced4da;
    padding-top: 15px !important;
  }

  .tooltip-inner {
    background: white !important;
    color: #333 !important;
    max-width: max-content !important;
  }

  .icon {
    display: block;
    width: 17px;
    height: 19px;
    background: #5BBFDE;
    margin: 0 auto;
  }

  .cool_mark {
    display: flex;
    align-items: center;
    padding: 0 4px;
    border: 1px solid #ced4da;
    border-left: 0;
    height: 38px;
  }

  .cool_mark .icon.icon-fa-percent {
    color: #5BBFDE;
    background: white;
  }

  .info_drug_popover_wrapper {
    min-width: 350px;
  }

  .info_drug_popover {
    background-color: white;
    color: #333;
    padding: 1rem;
    overflow: hidden;
  }

  .main_div {
    width: 100%;
  }

  .drug_select .vs__dropdown-toggle {
    height: auto !important;
    max-height: 117px;
    min-height: 38px;
    border-radius: 0;
  }

  .drug_select {
    min-width: 550px;
  }

</style>
